@if (
  {
    value: value$ | async,
    isCombo:
      type === Types.Combo || (!isInline && (newSelected || ss.optionLabelPrefixes.size || ss.selectLabelPrefix)),
    labels: (ss.optionLabels$ | async),
    isMultiSelect: ss.isMultiSelect$ | async,
  };
  as data
) {
  @if (!selectContainer) {
    <div
      class="z-fx-inline select"
      [ngClass]="'select-' + type + ' select-' + size"
      [class.zef-text-p2]="!isInline || type === Types.InlineP2"
      [class.zef-text-h3]="type === Types.InlineH3"
      [class.zef-text-h4]="type === Types.InlineH4"
      [class.select-combo]="data.isCombo"
      [class.space]="space"
      [class.disabled]="disabled"
      [class.read-only]="readOnly"
      [class.select-small]="valuePrefixOnly"
      [tabindex]="disabled ? -1 : 0"
      (click)="openSelect()"
    >
      @if (!data.isMultiSelect) {
        @if (!newSelected && data.value != null) {
          <select-item
            [class.zef-text-p2]="!isInline || type === Types.InlineP2"
            [class.zef-text-h3]="type === Types.InlineH3"
            [class.zef-text-h4]="type === Types.InlineH4"
            [label]="valuePrefixOnly ? undefined : ss.selectLabel || data.labels?.get(data.value)"
            [valuePrefixOnly]="valuePrefixOnly"
            [prefix]="
              isInline && !showInlineIcon
                ? null
                : loading
                  ? loadingIcon
                  : ss.optionLabelPrefixes.get(data.value) || ss.selectLabelPrefix
            "
            [value]="data.value"
            [isMultiSelect]="data.isMultiSelect"
            (selectItemOverflow)="selectOverflow.emit($event)"
          ></select-item>
        } @else {
          <ng-template #newPrefix>
            <mat-icon [color]="newValue || newPrefixIcon ? 'ink' : 'ink-lighter'">
              {{ newValue ? 'plus' : newPrefixIcon || 'question_unknown' }}
            </mat-icon>
          </ng-template>
          <ng-template #newLabel>
            @if (!newValue) {
              @if (placeholder) {
                {{ placeholder }}
              }
              @if (!placeholder) {
                <ng-container i18n>Select</ng-container>
              }
            }
            @if (newValue) {
              {{ newValue }}
            }
          </ng-template>
          <select-item
            [class.zef-text-p2]="!isInline || type === Types.InlineP2"
            [class.zef-text-h3]="type === Types.InlineH3"
            [class.zef-text-h4]="type === Types.InlineH4"
            [label]="newLabel"
            [prefix]="
              data.isCombo || loading || useNewPrefix
                ? loading
                  ? loadingIcon
                  : canNew || useNewPrefix
                    ? newPrefix
                    : noPlaceholderPrefix
                      ? null
                      : ss.selectLabelPrefix || newPrefix
                : null
            "
            [placeholder]="!newValue"
            [isMultiSelect]="data.isMultiSelect"
          ></select-item>
        }
      } @else {
        @if (!ss?.selectLabel) {
          @if (!ss?.selectLabel) {
            @if (data.value?.length > 1) {
              <span>{{ data.value?.length + ' ' + selectedText }}</span>
            }
            @if (data.value?.length === 1) {
              @if (data.labels?.get(data.value?.[0])) {
                <ng-container [ngTemplateOutlet]="data.labels?.get(data.value?.[0])"></ng-container>
              } @else {
                <span>{{ data.value?.[0] }}</span>
              }
            }
            @if (newSelected && data.value == null) {
              <span>{{ newValue }}</span>
            } @else {
              @if (!data.value?.length) {
                <span class="zef-color-ink-lightest">{{ placeholder }}</span>
              }
            }
          }
        } @else {
          <ng-container [ngTemplateOutlet]="ss.selectLabel"></ng-container>
        }
      }
      <span class="z-fx z-fx-center-center select-suffix">
        @if (!selectSuffix) {
          <mat-icon class="z-fx-none select-pointer" [@rotate]="isOpen">pointer_down</mat-icon>
        } @else {
          <ng-template [ngTemplateOutlet]="selectSuffix?.tr"></ng-template>
        }
      </span>
    </div>
  } @else {
    <div (click)="openSelect()">
      <ng-container *ngTemplateOutlet="selectContainer.tr"></ng-container>
    </div>
  }
}

<div
  *cdkPortal
  class="z-fx-col select-list"
  [class.overlay]="isNewOpen"
  [@dropdown]="dropdownState"
  cdkTrapFocus
  (@dropdown.done)="onDropdownAnimationDone($event)"
>
  @if (!isNewOpen) {
    @if (canSearch || loading) {
      <div class="z-fx-none select-header select-search">
        @if (loading) {
          <mat-progress-bar mode="query"></mat-progress-bar>
        }
        @if (canSearch) {
          <mat-form-field class="zef-search-input">
            <mat-icon matPrefix>action_find</mat-icon>
            <input
              matInput
              [value]="ss.search$ | async"
              [placeholder]="placeholderSearch"
              (input)="!searchOnEnter && onSearchInput(searchInput.value)"
              (keydown.enter)="searchOnEnter && onSearchInput(searchInput.value)"
              (blur)="searchOnEnter && onSearchInput(searchInput.value)"
              #searchInput="matInput"
            />
          </mat-form-field>
        }
      </div>
    }
    <div class="z-fx-col z-fx-flex">
      <div class="zef-scroll-y" [class.multi-select-scroll]="ss.isMultiSelect$ | async">
        <div class="select-options" [class.multi-select-options]="ss.isMultiSelect$ | async">
          @if (canClear) {
            <zef-select-option [value]="null">
              <mat-icon *selectPrefix>remove</mat-icon>
              <ng-container *selectOptionLabel>
                @if (!clearHint) {
                  <ng-container i18n>None</ng-container>
                }
                @if (clearHint) {
                  <ng-container i18n>{{ clearHint }}</ng-container>
                }
              </ng-container>
            </zef-select-option>
            <mat-divider></mat-divider>
          }
          @if (canNew) {
            <zef-select-option [value]="newValue" [isNew]="true">
              <mat-icon *selectPrefix>plus</mat-icon>
              <ng-container *selectOptionLabel>
                @if (!newHint) {
                  <ng-container i18n>Create new</ng-container>
                }
                @if (newHint) {
                  <ng-container i18n>{{ newHint }}</ng-container>
                }
              </ng-container>
            </zef-select-option>
            <mat-divider></mat-divider>
          }
          @if (selectOptions?.template) {
            <ng-container
              [ngTemplateOutlet]="selectOptions?.template"
              [ngTemplateOutletContext]="{ $implicit: (value$ | async) }"
            ></ng-container>
          }
          @if (!selectOptions?.template) {
            <ng-content></ng-content>
          }
        </div>
      </div>
      @if (ss.confirm$ | async) {
        <div class="z-fx z-fx-between-center z-fx-none select-footer">
          <ng-container *ngTemplateOutlet="selectFooterContent?.tr"></ng-container>
          <button
            mat-raised-button
            color="primary"
            [disabled]="$any(value$ | async)?.length < ((ss.minSelected$ | async) || 0)"
            (click)="closeSelect(true)"
            i18n
          >
            Confirm
          </button>
        </div>
      }
    </div>
  }

  @if (isNewOpen) {
    <div>
      <div class="z-fx z-fx-start-center z-fx-gap-8 zef-text-p1 select-header">
        <button mat-icon-button (click)="closeNewInput()">
          <mat-icon>back</mat-icon>
        </button>
        @if (!newHint) {
          <span i18n>Create new</span>
        }
        @if (newHint) {
          <span i18n>{{ newHint }}</span>
        }
      </div>
      <div class="select-body">
        <mat-form-field>
          <input
            matInput
            [placeholder]="placeholderNew"
            [value]="newValue"
            (keydown.enter)="onNewValue(newInput.value)"
            #newInput="matInput"
          />
          <mat-icon matSuffix [class.empty]="!newInput.value" (click)="onNewValue(newInput.value)">
            bullet_check
          </mat-icon>
        </mat-form-field>
      </div>
    </div>
  }
</div>

<ng-template #loadingIcon>
  <zef-spinner></zef-spinner>
</ng-template>
